export enum SwiperType {
	SHOW_FIRST = "show-first",
	CENTERED = "centered",
}
